import { config, socials } from "../utils";
import { Link } from "react-router-dom";
const ContactComp = () => {
  return (
    <>
      <div className="container-xxl py-5">
        <div className="container contact px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div
              className="col-lg-6 contact-text py-5 wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="p-lg-5 ps-lg-0">
                <h6 className="text-primary">Contact Us</h6>
                <h1 className="mb-4">Feel Free To Contact Us</h1>
                <p className="mb-2">
                  <i className="text-primary fa fa-map-marker-alt me-1"></i>
                  {`${config.address1} ${config.address2} ${config.address3}`}
                </p>
                <p className="mb-2">
                  <i className="text-primary fa fa-envelope me-1"></i>
                  {config.email}
                </p>
                <div className="d-flex pt-2">
                  {socials.map((social, index) => {
                    return (
                      <Link
                        key={index}
                        className={`btn btn-primary btn-square btn-social ${
                          index > 0 ? "ms-2" : ""
                        }`}
                        to={social.url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className={`fab ${social.icon}`}></i>
                      </Link>
                    );
                  })}
                </div>
                {/*       <p className="mb-4">
                  The contact form is currently inactive. Get a functional and
                  working contact form with Ajax & PHP in a few minutes. Just
                  copy and paste the files, add a little code and you're done.{" "}
                  <a href="https://htmlcodex.com/contact-form">Download Now</a>.
                </p>
                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Your Name"
                        />
                        <label for="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Your Email"
                        />
                        <label for="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          placeholder="Subject"
                        />
                        <label for="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Leave a message here"
                          id="message"
                        ></textarea>
                        <label for="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary rounded-pill py-3 px-5"
                        type="submit"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form> */}
              </div>
            </div>
            <div className="col-lg-6 pe-lg-0" style={{ minHeight: "400px" }}>
              <div className="position-relative h-100">
                <iframe
                  className="position-absolute w-100 h-100"
                  src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Maitri%20Trust,%201-B%20Orchard%20Court%20123/63,%20Chamiers%20Road%20R.A.%20Puram,%20Chennai-%20600028&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                  frameborder="0"
                  allowfullscreen=""
                  aria-hidden="false"
                  tabindex="0"
                  title={"Map"}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactComp;
